import { parseNumberArg } from '@/utils/string'

import type { RouteRecordRaw } from 'vue-router'

export default [
  {
    path: 'order/list',
    name: 'order-list',
    meta: { title: '订单列表', componentName: 'OrderList' },
    component: () => import('@/views/pc/order/OrderList.vue'),
    props: true
  },
  {
    path: 'order/:orderId(\\d+)/items',
    name: 'order-items',
    meta: { title: '订单项列表', componentName: 'OrderItemList' },
    component: () => import('@/views/pc/order/OrderItemList.vue'),
    props: (to) => ({ orderId: parseNumberArg(to.params.orderId) })
  },
  {
    path: 'withdraw/list',
    name: 'withdraw-list',
    meta: { title: '提现列表', componentName: 'WithdrawOrderList' },
    component: () => import('@/views/pc/order/WithdrawOrderList.vue'),
    props: true
  }
] as RouteRecordRaw[]
